import { createRouter, createWebHistory } from "vue-router"
import PageTemplate from "../templates/PageTemplate.vue"
import IframeTemplate from "@/iframe/IframeTemplate.vue"
import YleispalveluhakuIframe from "@/iframe/YleispalveluhakuIframe.vue"
import utils from "../utils/utils"

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
    {
        path: "/iframe/:iframeName", // HUOM: Järjestyksellä on väliä, tämä pitää olla ennen /:type pathia.
        name: "iframe",
        component: IframeTemplate
    },
    {
        path: "/yleispalveluhaku",
        name: "Yleispalveluhaku",
        component: YleispalveluhakuIframe
    },
    {
        path: "/:type/:pageName",
        name: "pageTemplate",
        component: PageTemplate,
        props: route => ({ required: false, query: route.query.subTopic })
    },
    {
        path: "/:type",
        name: "pageTemplateWithoutPageName",
        component: PageTemplate
    },
    {
        path: "/",
        name: "pageTemplateRoot",
        component: PageTemplate
    },
    {
        // path: "/:type/:pageName/:catchAll(.*)",
        path: '/:type/:pageName/:pathMatch(.*)*',
        name: "pageNotFoundTemplate",
        component: PageTemplate,
        props: {
            isNotFound: true
        }
    }
]
})

router.afterEach((to) => {
    utils.changePageTitle(to)
})

export default router
